module.exports = __webpack_public_path__ + "img/truelab.db71adcc.svg";